import { render, staticRenderFns } from "./MailFilters.vue?vue&type=template&id=17662307&scoped=true"
import script from "./MailFilters.vue?vue&type=script&lang=js"
export * from "./MailFilters.vue?vue&type=script&lang=js"
import style0 from "./MailFilters.vue?vue&type=style&index=0&id=17662307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17662307",
  null
  
)

export default component.exports